import "./import/modules";
import $ from "jquery";

$(".modal").each( function(){
	$(this).wrap('<div class="overlay"></div>')
});

$(".open-modal").on('click', function(e){
	e.preventDefault();
	e.stopImmediatePropagation;
	
	var $this = $(this),
			modal = $($this).data("modal");
	
	$(modal).parents(".overlay").addClass("open");
	setTimeout( function(){
		$(".header").addClass("z-index-one");
		$(".top-btn").addClass("z-index-one");
		$(modal).addClass("open");
		$("html").addClass("body-modal");
	}, 350);
	
	$(document).on('click', function(e){
		var target = $(e.target);
		
		if ($(target).hasClass("overlay")){
			$(target).find(".modal").each( function(){
				$(".header").removeClass("z-index-one");
				$(".top-btn").removeClass("z-index-one");
				$(this).removeClass("open");
                $("html").removeClass("body-modal");
			});
			setTimeout( function(){
				$(".header").removeClass("z-index-one");
				$(".top-btn").removeClass("z-index-one");
				$(target).removeClass("open");
                $("html").removeClass("body-modal");
			}, 350);
		}
		
	});
	
});

$(".close-modal").on('click', function(e){
	e.preventDefault();
	e.stopImmediatePropagation;
	
	var $this = $(this),
			modal = $($this).data("modal");
	$(".header").removeClass("z-index-one");
	$(".top-btn").removeClass("z-index-one");
    $(modal).removeClass("open");
	$("html").removeClass("body-modal");
	setTimeout( function(){	
		$(modal).parents(".overlay").removeClass("open");
	}, 350);
	
});	

var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    load_delay: 300
});
